<template>
    <div class="case_card card_bottom-padding caseInfo">
        <el-row class="title_row">
            <el-col :span="12">
                <div class="card_title">同一投诉电话统计</div>
            </el-col>
        </el-row>
        <div class="card_content">
            <el-table :data="phoneComplaintList" style="width: 100%" max-height="280">
                <el-table-column label="序号" width="45">
                    <template slot-scope="scope"> {{ scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column prop="complaintPhone" label="投诉电话1" width="110"> </el-table-column>
                <el-table-column prop="complaintPhone2" label="投诉电话2" width="110"> </el-table-column>
                <el-table-column prop="complaintNumber" label="投诉编号"> </el-table-column>
                <el-table-column prop="policyNo" label="保单号"> </el-table-column>
                <el-table-column prop="remark" label="备注" width="180">
                    <template slot-scope="scope">
                        <overflow-txt :txt="scope.row.remark ? scope.row.remark : ''"></overflow-txt>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        caseDetailData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            phoneComplaintList: []
        };
    },
    mounted() {},
    methods: {},
    watch: {
        caseDetailData: {
            handler(val) {
                if (val) {
                    this.phoneComplaintList = val.phoneComplaintList || [];
                }
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/caseCard.css';
.caseInfo {
    .title_row {
        .btn_groups {
            text-align: right;
        }
    }
    .card_content {
        padding-bottom: 20px;
    }
}
</style>